// extracted by mini-css-extract-plugin
export default {"wrapper":"edit-sms-consent__wrapper--fuQfM"};